import { useIntl } from "react-intl";

import type { PackingListRow } from "@RequestFormV2/sections/PackingList/types";
import {
  formatBooleanValue,
  formatCratingBy,
  formatDangerousGood,
  formatTemperatureControl,
  type ReviewPackingListLabelContext,
} from "@RequestFormV2/components/ReviewPage/sections/ReviewPackingList/reviewPackingListFormatters";

type ReviewPackingListHandlingCellProps = {
  row: PackingListRow;
  labelContext: ReviewPackingListLabelContext;
};

function HandlingLine({ label, value }: { label: string; value: string }) {
  return (
    <p className="rfv2-review-packing-list__handling-line">
      {label} <span className="rfv2-review-packing-list__handling-value">{value}</span>
    </p>
  );
}

export default function ReviewPackingListHandlingCell({ row, labelContext }: ReviewPackingListHandlingCellProps) {
  const intl = useIntl();
  const { hazardousEnabled, temperatureEnabled, dangerousEnabled, cratingEnabled } = labelContext;

  const lines = [
    {
      label: intl.formatMessage({
        id: "request-form.review.packingList.stackables",
        defaultMessage: "Stackables:",
      }),
      value: formatBooleanValue(row.stackable, intl),
    },
    ...(hazardousEnabled
      ? [
          {
            label: intl.formatMessage({
              id: "request-form.review.packingList.hazardous",
              defaultMessage: "Hazardous:",
            }),
            value: formatBooleanValue(row.hazardous, intl),
          },
        ]
      : []),
    ...(cratingEnabled
      ? [
          {
            label: intl.formatMessage({
              id: "request-form.review.packingList.cratingBy",
              defaultMessage: "Crating by:",
            }),
            value: formatCratingBy(row),
          },
        ]
      : []),
    ...(temperatureEnabled
      ? [
          {
            label: intl.formatMessage({
              id: "request-form.review.packingList.tempControl",
              defaultMessage: "Temp. control:",
            }),
            value: formatTemperatureControl(row, labelContext),
          },
        ]
      : []),
    ...(dangerousEnabled
      ? [
          {
            label: intl.formatMessage({
              id: "request-form.review.packingList.dg",
              defaultMessage: "DG:",
            }),
            value: formatDangerousGood(row, labelContext),
          },
        ]
      : []),
  ];

  return (
    <div className="rfv2-review-packing-list__handling-cell">
      {lines.map((line) => (
        <HandlingLine key={line.label} label={line.label} value={line.value} />
      ))}
    </div>
  );
}
